/* tslint:disable:no-access-missing-member */
// https://github.com/mgechev/codelyzer/issues/191 for the above
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ReferralPageBannerService } from '../home/referral-page-banner/referral-page-banner.service';
import { EduSynchModalComponent } from '../shared/edusynch-modal/edusynch-modal.component';
import { OeAppPersonService } from '../shared/oe-app-person.service';
import { OeAppService } from '../shared/oe-app.service';
import { ProfileService } from '../shared/profile.service';
import { RequireAdapterService } from '../shared/require-adapter.service';
import { TranslationService } from '../shared/translation.service';
import { PasswordSetupType } from '../shared/types/PasswordSetupType';
import { Country, TOOLS_UNSUPPORTED_COUNTRIES } from '../shared/types/countries';
import { HidableMenuKeys } from '../shared/types/hidable-menu-keys';
import { ChatBotStateService } from '../shared/chat-bot-state.service';
import { GTMService } from '../shared/gtm.service';
import { ChatBotTrackEvents } from '../shared/types/chat-bot-track-events.enum';
import { WindowService } from '../shared/window.service';
import { LogoutService } from '../shared/logout.service';

export const HEADER_SELECTOR = 'lp2-header';

@Component({
  selector: HEADER_SELECTOR,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  s3BucketUrl: string;
  // We always want the navbar collapsed, but on desktop,
  //  we'll overwrite the CSS so that a collapsed bar is visible
  // We want to avoid Typescript detection of mobile if at all
  //  possible.
  isNavbarCollapsed = true;
  isToolbarCollapsed = true;
  // We shouldn't be detecting mobile this way, but until
  //  we enable responsive meta tags, we can't detect
  //  mobile resolutions
  isMobile: boolean;

  isLoginNavigation: boolean;
  isNavigationDisabled: boolean;
  fullName: string;

  isB2bStudent = false;
  liveClassEnabled: boolean;
  gamificationEnabled$: Observable<boolean>;

  gamificationS3Url = `//${this.oeApp.s3BucketHost()}/gamification`;

  language = 'en';
  faqLink: string;

  showReferralProgramLink$ = this.referralPageBannerService.showHeaderLink$;

  destroy = new Subject<boolean>();

  hasLiveChatAccess$ = this.profileService.address$.pipe(
    map(({ countryISO }) => !TOOLS_UNSUPPORTED_COUNTRIES.includes(countryISO as Country))
  );

  testPrepEnabled = this.oeAppPerson.testPrepEnabled;

  platformTourEnabled = this.oeAppPerson.platformTourEnabled;

  lessonEnabled = this.oeAppPerson.lessonEnabled;

  readonly menuKeys = HidableMenuKeys;

  showChatBotButton$ = this.chatBotStateService.state$.pipe(
    map(({ showHeaderButton }) => {
      return showHeaderButton && !this.isMobile && new URL(this.windowService.getHref()).pathname === '/';
    })
  );

  constructor(
    private oeApp: OeAppService,
    private readonly oeAppPerson: OeAppPersonService,
    requireAdapter: RequireAdapterService,
    private readonly modalService: NgbModal,
    private translationService: TranslationService,
    private referralPageBannerService: ReferralPageBannerService,
    private readonly profileService: ProfileService,
    private readonly chatBotStateService: ChatBotStateService,
    private readonly gtmService: GTMService,
    private readonly windowService: WindowService,
    private readonly logoutService: LogoutService
  ) {
    this.language = this.translationService.getCurrentLanguage();

    const { firstName, lastName, id, oePlacementTestTaken } = oeAppPerson.getPersonData();

    const isLoggedIn = !!id;
    const setupType = oeApp.getData('passwordSetupType');
    const isInPasswordSetup = setupType === PasswordSetupType.TOKEN || setupType === PasswordSetupType.MIGRATION;
    this.isLoginNavigation = !isLoggedIn || isInPasswordSetup;
    this.isNavigationDisabled = this.isLoginNavigation || !oePlacementTestTaken;

    this.fullName = `${firstName} ${lastName}`;
    this.s3BucketUrl = oeApp.s3BucketHost();
    this.isMobile = oeApp.isMobileDevice();

    if (!this.isNavigationDisabled) {
      const SysMsgService = requireAdapter.loadSysMessages();
      const sysMsg = new SysMsgService();
      sysMsg.start();
      sysMsg.render();
    }
  }

  ngOnInit() {
    this.isB2bStudent = this.oeAppPerson.isB2bStudent();
    this.liveClassEnabled = this.oeAppPerson.liveClassEnabled;
    this.faqLink = this.translationService.translate('oeApp.faq.link');
  }

  toggleNavbarCollapse() {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
    if (!this.isNavbarCollapsed) {
      this.isToolbarCollapsed = true;
    }
  }

  toggleTools() {
    this.isToolbarCollapsed = !this.isToolbarCollapsed;
    if (!this.isToolbarCollapsed) {
      this.isNavbarCollapsed = true;
    }
  }

  openEduSynch() {
    this.modalService.open(EduSynchModalComponent);
  }

  ngOnDestroy() {
    this.destroy.next(true);
    this.destroy.unsubscribe();
  }

  isMenuItemHidden(key: string): boolean {
    return this.oeAppPerson.hideMenuItems.map((item) => item.toLowerCase()).includes(key.toLowerCase());
  }

  openChatBotModal() {
    this.chatBotStateService.openChatBotModal();
    this.gtmService.sendGA4Event(ChatBotTrackEvents.COPILOT_HEADER_SPEAK_WITH_JENNY);
  }

  logout() {
    this.logoutService.logout();
  }
}



// WEBPACK FOOTER //
// ./ts/app/header/header.component.ts